export default [{
    country: 'Malaysia',
    states: [
        'Selangor',
        'WP Kuala Lumpur',
        'Johor',
        'Kedah',
        'Kelantan',
        'Melaka',
        'Negeri Sembilan',
        'Pahang',
        'Penang',
        'Perak',
        'Sabah',
        'Sarawak',
        'Terengganu',
    ],
    shippingFee: 7,
}, {
    country: 'Singapore',
    states: [
        'Central Region',
        'East Region',
        'North Region',
        'North-East Region',
        'West Region',
    ],
    shippingFee: 85,
},
];
